export default "__VITE_ASSET__BR2PFLko__"